import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import {
  FormErrorMessage,
  Container,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  HStack,
  Alert,
  // アイコンリスト // Icon - Chakra UI https://chakra-ui.com/docs/components/icon
  AlertIcon,
  AlertTitle,
  Box, Text,
  Image,
  Flex,
} from "@chakra-ui/react";
// import {useState} from "react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

import {client} from "@/client"
import {setBearerToken} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

import './LoginForm.css';

const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box bg="white" px={2} >
        {/* ロゴ部分 */}
        <Image src="/ap/img/usaprologo2.png" objectFit="contain" p={3} height="6em" onClick={() => navigate("../login")}/>
    </Box>
  );
};

const Footer: React.FC = () => {
  return (
    <Box bg="#002060" color="white" py={2}>
      {
        /* フッターの上部 */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        px={4}
      >

        <Box borderRadius={"4px"} border={"1px"} borderColor={"white"}>
          <Text m={"0.5em"}>事業再構築</Text>
        </Box>

        {/* yuberロゴ部分 */}
        <Box>
          <Image src="/ap/img/yuberlogo.png" objectFit="contain" p={2} height="5em"/>
        </Box>

      </Flex>
    </Box>
  );
};

type FormDataIDPASS = {
  memberId: string;
  password: string;
};

type FormDataCODE = {
  code: string;
};


export const Mlogin = () => {

  const [formIDPASSError, setFormIDPASSError] = useState('');

  const {
    register: registerIDPASSElement,
    handleSubmit: handleSubmitFormIDPASS,
    formState: { errors: formIDPASSErrors },
  } = useForm<FormDataIDPASS>();


  const navigate = useNavigate();

  const submitIDPASSIfValid : SubmitHandler<FormDataIDPASS> = (async (data) => {

      const id = data.memberId.trim();
      const password =  data.password.trim();

      const resp = await client.login({
        id: id,
        password: password,
        code: "",
      })
      
      if (!resp.error) {
        console.log("Succeeded to login");
        setBearerToken(resp.bearerToken)
        if (resp.currentUser?.optRole === "student") {
          navigate("/works")
        } else {
          navigate('/manage');
        }
      } else {
        console.log("Failed to login");
        setFormIDPASSError(`ログイン失敗。 ${resp.error.message}`);
      }
  });

  return <Page>
    <Box>

      {/* ヘッダー */}
      <Header />
  
      {/* 中身 */}
      <Box as="form" onSubmit={handleSubmitFormIDPASS(submitIDPASSIfValid)}
        display="flex" justifyContent="center" alignItems="center" p={20}>

          <VStack className="section_block">

            <FormControl>
              <div className="section_titie">うさプロ管理画面ログイン</div>
            </FormControl>

            <HStack spacing={6}>

              <FormControl isInvalid={Boolean(formIDPASSErrors.memberId)} >
                <FormLabel><span>ID</span></FormLabel>
                <Input className="login_form_short"
                  {...registerIDPASSElement("memberId", {
                        required: "IDを入力してください。",
                      })
                  }
                />
                <FormErrorMessage>
                  { formIDPASSErrors.memberId && formIDPASSErrors.memberId.message }
                </FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={Boolean(formIDPASSErrors.password)}>
                <FormLabel htmlFor="passwordElem"><span>パスワード</span></FormLabel>
                <Input className="login_form_middle"
                  type="password"
                  placeholder="password"
                  {...registerIDPASSElement("password", {
                        required: "パスワードを入力してください。",
                      })
                  }
                />
                <FormErrorMessage>
                  { formIDPASSErrors.password && formIDPASSErrors.password.message }
                </FormErrorMessage>
              </FormControl>
  
            </HStack>

            <Button className="login_form_button" type="submit">ログイン</Button>

            {
              formIDPASSError && <Alert status="error">
                  <AlertIcon />
                  <AlertTitle>{formIDPASSError}</AlertTitle>
                  {/*<AlertDescription>{formIDPASSError}</AlertDescription>*/}
                </Alert>
            }
  
          </VStack>

      </Box>

      {/* フッター */}
      <Footer />

    </Box>
  </Page>
}



